<template>
  <div class="search-criteria-box">
    <h4 class="tit-search-type is-bgc-red400">ボトルレス</h4>
    <!-- <img src="/images/cmn/ico-bottleless.png" class="img-fluid mx-auto" alt="" width="300" height="200"> -->
    <div class="search-radio-set">
      <template v-for="option in options">
        <input type="radio"
        :name="name"
        :id="`label7-${option.id}`"
        :key="`radio7-${option.id}`"
        :value="option.data"
        @change="updateValue(option.data, option.flag)"
        >
        <label :key="`label7-${option.id}`" :for="`label7-${option.id}`" v-html="option.value"></label>
    </template>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {},
    options: { type: Array },
    name: { type: String },
  },
  methods: {
    updateValue: function(value, flag) {

      let WithstandLoad = {"A":true,"B":true,"C":true,"D":true,"E":true};
      let heightList = {"A":true,"B":true,"C":true};
      let widthList = {"A":true,"B":true,"C":true,"D":true,"E":true};
      let depthList = {"A":true,"B":true,"C":true};

      if(value === "受注生産 スチールラック"){
        WithstandLoad = {"A":true,"B":true,"C":true,"D":true,"E":true};
        heightList = {"A":true,"B":true,"C":true};
        widthList = {"A":true,"B":true,"C":true,"D":true,"E":true};
        depthList = {"A":true,"B":true,"C":true};
      } else {
        WithstandLoad = {"A":true,"B":true,"C":true,"D":false,"E":false};
        // heightList = {"A":false,"B":false,"C":true};
        heightList = {"A":true,"B":true,"C":true};
        widthList = {"A":true,"B":true,"C":true,"D":false,"E":true};
        depthList = {"A":false,"B":true,"C":false};
      }
      
      this.$emit('WithstandChange', WithstandLoad);
      this.$emit('HeightChange', heightList);
      this.$emit('widthChange', widthList);
      this.$emit('depthChange', depthList);

      this.$emit('BottleFlag', flag);
      this.$emit("input", value);
    }
  }
}
</script>